import React from 'react';
import logoOnDark from '../assets/Logo.png';
import logoOnLight from '../assets/logo-on-light.png';

/**
 * The Akeyreu logo. The artwork is white, so it needs an ink-coloured twin
 * for light grounds — logo-on-light.png is Logo.png with the white
 * letterforms recoloured and the blue left alone. Both are the same lockup
 * at the same size, so swapping between them doesn't shift the layout.
 *
 * `on` names the background it sits against, not the colour of the mark.
 */
const Logo = ({ on = 'light', className = '' }) => (
  <img
    src={on === 'dark' ? logoOnDark : logoOnLight}
    alt="Akeyreu"
    className={`ak-logo ${className}`.trim()}
    width="404"
    height="64"
  />
);

export default Logo;
